<template>
  <v-card class="file-box">
    <v-card-text class="pa-0">
      <v-row no-gutters>
        <v-col cols="12" class="file-box__title">
          <p class="font--m-9 mb-2">업로드된 주문 목록</p>
          <p class="font--m-7 mb-0" style="line-height: 1.3">
            파일을 기반으로 신청이 접수됩니다.<br />
            결과는 유선으로 안내될 예정입니다.
          </p>
        </v-col>
      </v-row>

      <v-row no-gutters>
        <HrSolid :classes="['my-2']" />
        <v-col cols="12" class="file-box__contents">
          <template v-if="isLoading">
            <LoadingText loading />
          </template>
          <template v-else>
            <p v-for="file in files" :key="file.uuid">
              {{ file.filename }}
            </p>
          </template>
        </v-col>
      </v-row>
    </v-card-text>
  </v-card>
</template>

<script>
import { mapActions } from 'vuex'
import LoadingText from '@/components/common/text/LoadingText.vue'

export default {
  props: {
    date: {
      type: String,
      required: true,
      default: null,
    },
  },
  components: {
    LoadingText,
  },
  data() {
    return {
      isLoading: false,
      files: [],
    }
  },
  created() {
    this.getFiles()
  },
  methods: {
    ...mapActions('product', ['getProductFiles']),
    async getFiles() {
      this.isLoading = true

      try {
        const result = await this.getProductFiles({ date: this.date })
        this.files = result
      } finally {
        this.isLoading = false
      }
    },
  },
}
</script>
<style lang="scss" scoped>
.file-box {
  text-align: left;

  padding: 15px 10px;

  &__contents {
    p {
      margin-bottom: 0;
    }
  }
}
</style>
